import * as React from 'react';
/** @jsx jsx */
import { jsx, useThemeUI } from 'theme-ui';
import { defineMessages, FormattedHTMLMessage, FormattedMessage, useIntl } from 'react-intl';
import { Code } from 'PubListDocumentation/utils';

const messages = defineMessages({
	section1_code: { id: 'hhu.publist.doc.section1.code' },
	section3_code: { id: 'hhu.publist.doc.section3.code' },
	section4_code: { id: 'hhu.publist.doc.section4.code' },
});

export const PubListDocsHHU: React.FC = () => {
	const intl = useIntl();
	const { theme } = useThemeUI();

	return (
		<article
			sx={{
				maxWidth: '1400px',
				mx: 'auto',
        py: 9,
				section: {
          px: 12,
					mt: '2em',
				},
				h1: {
					variant: 'styles.h1',
				},
				h2: {
					variant: 'styles.h2',
					mb: '0.2em'
				},
				a: { variant: 'styles.a' },
				ul: {
					my: '0.5em',
					pl: '1em',
					listStyleType: 'none',
					listStylePosition: 'inside',
					li: {
						'::before': {
							content: '"\\2022"',
							color: 'primary',
							mr: '0.5em'
						}
					},
				},
				ol: {
					my: '0.5em',
					pl: '2em',
					li: {
						pl: '0.5em'
					}
					/*
					listStyleType: 'none',
					counterReset: 'li',
					li: {
						'::before': {
							counterIncrement: 'li',
							content: 'counter(li) "."',
							color: 'primary',
							mr: '0.5em'
						}
					},
					*/
				}
			}}
		>
			<h1>
				<FormattedMessage id="hhu.publist.doc.title" />
			</h1>
			<section>
				<h2>
					<FormattedHTMLMessage id="hhu.publist.doc.section1.title" />
				</h2>
				<p>
					<FormattedHTMLMessage id="hhu.publist.doc.section1.text" />
					{Code(intl.formatMessage(messages.section1_code), theme)}
				</p>
			</section>
			<section>
				<h2>
					<FormattedHTMLMessage id="hhu.publist.doc.section2.title" />
				</h2>
				<p>
					<FormattedHTMLMessage id="hhu.publist.doc.section2.text" />
				</p>
			</section>
			<section>
				<h2>
					<FormattedHTMLMessage id="hhu.publist.doc.section3.title" />
				</h2>
				<p>
					<FormattedHTMLMessage id="hhu.publist.doc.section3.text" />
					{Code(intl.formatMessage(messages.section3_code), theme)}
				</p>
			</section>
			<section>
				<h2>
					<FormattedHTMLMessage id="hhu.publist.doc.section4.title" />
				</h2>
				<p>
					<FormattedHTMLMessage id="hhu.publist.doc.section4.text" />
					{Code(intl.formatMessage(messages.section4_code), theme)}
				</p>
			</section>
		</article>
	);
};

export default PubListDocsHHU;